import { createContext, ReactNode, useCallback, useContext, useState } from "react";

interface ThemeContextType {
    darkMode: boolean;
    toggleDarkMode: () => void;
}

export const ThemeContext = createContext<ThemeContextType>({
    darkMode: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleDarkMode: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    const [darkMode, setDarkMode] = useState(() => {
        try {
            const saved = localStorage.getItem("darkMode");
            return saved === "true";
        } catch {
            return false;
        }
    });

    const toggleDarkMode = useCallback(() => {
        setDarkMode((prev) => {
            const next = !prev;
            try {
                localStorage.setItem("darkMode", String(next));
            } catch {
                // Ignore persistence errors and keep using in-memory state
            }
            return next;
        });
    }, []);

    return (
        <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
            {children}
        </ThemeContext.Provider>
    );
};
